<template>
  <div style="height:100%">
    <div class="flex-sb">
      <div style="width: 50%;">
        <div class="detail-title">
          {{listRecordDetail.name}}详情
        </div>
        <div class="flex" style="margin-top: 8px; margin-bottom: 8px;">
          <div style="height: 18px; margin-right: 48px;">
            <img src="../assets/u53.png" alt="" class="icon-size" align="absmiddle">
            <div style="font-size: 14px; display: inline-block; height: 18px; line-height: 18px;" class="icon-text">
              &nbsp;&nbsp;总第{{listRecordDetail.version}}期
            </div>
          </div>
          <div style="height: 18px;">
            <img src="../assets/u55.png" alt="" class="icon-size" align="absmiddle">
            <div style="font-size: 14px; display: inline-block; height: 18px; line-height: 18px;" class="icon-text">
              &nbsp;&nbsp;时点：{{listRecordDetail.date}}
            </div>
          </div>
        </div>
      </div>
      <div class="flex" style="align-items: center;">
        <div>
          <el-button @click="downLoadPdf" size="medium">导出PDF</el-button>
          <el-button @click="downLoadExcel" size="medium" v-if="isAssociation">导出EXCEL</el-button>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" class="content" id="tabs">
      <el-tab-pane label="标准房" name="standardRoom">
        <div class="mb-8 text-center description-content">
          共有标准房： {{standardRoomPageForm.total}}个
        </div>
        <el-table :data="standardRoom" border class="mb-8" height="calc(100% - 88px)" style="overflow:auto">
          <el-table-column prop="number" fixed label="编码" min-width="80" align="center"></el-table-column>
          <el-table-column prop="type" fixed label="类型" min-width="100" align="center"></el-table-column>
          <el-table-column prop="name" fixed label="名称" min-width="100" align="center"></el-table-column>
          <el-table-column prop="building" fixed label="样点建筑物" min-width="100" align="center"></el-table-column>
          <el-table-column prop="area" fixed label="建筑面积（平方米）" min-width="100" align="center"></el-table-column>
          <el-table-column prop="layer" fixed label="层数" min-width="60" align="center"></el-table-column>
          <el-table-column prop="totalPrice" fixed label="平面造价（元）" min-width="100" align="center"></el-table-column>
          <el-table-column label="其中" fixed align="center" min-width="140">
            <el-table-column prop="buildPrice" fixed label="土建" min-width="70" align="center"></el-table-column>
            <el-table-column prop="installPrice" fixed label="安装" min-width="70" align="center"></el-table-column>
          </el-table-column>
          <el-table-column prop="constructionFeature" label="结构特征" min-width="350" align="center"></el-table-column>
          <el-table-column prop="architectureFeature" label="建筑特征" min-width="350" align="center"></el-table-column>
          <el-table-column prop="equipmentFeature" label="安装设备特征" min-width="150" align="center"></el-table-column>
          <el-table-column prop="safetyRate" label="安全文明措施费率(%)" min-width="60" align="center"></el-table-column>
          <el-table-column prop="otherRate" label="其他措施费率(%)" min-width="60" align="center"></el-table-column>
          <el-table-column prop="addedValueTaxRate" label="增值税率(%)" min-width="60" align="center"></el-table-column>
          <el-table-column label="操作" min-width="100" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button @click="standardRoomDetail($event, scope.row.id, scope.row.name)" size="small">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex-center">
          <el-pagination
            @current-change="standardRoomPageChange"
            :current-page.sync="standardRoomPageForm.page"
            :page-size="standardRoomPageForm.pageSize"
            layout="prev, pager, next"
            :total="standardRoomPageForm.total"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="清单库" name="listing">
        <div class="mb-8 flex-sb">
          <div class="text-center description-content">
            共有清单： {{listingPageForm.total}}项
          </div>
          <div style="display:flex;">
            <div style="max-width:720px;">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="float:left;width:120px">全选</el-checkbox>
              <el-checkbox-group v-model="listingSearchForm.type" @change="listingSearchFormTypeChange">
                <el-checkbox v-for="(value,key) in typeSearchList" :key="key" :label="key" style="margin-left:0;width:120px">{{value}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <el-input v-model="listingSearchForm.search" placeholder="清单库编码/名称/类型" @keyup.enter.native="listingPageChange(1)" style="width:380px">
              <el-button slot="append" icon="el-icon-search" @click="listingPageChange(1)" style="background: #fff;"></el-button>
            </el-input>
          </div>
        </div>
        <el-table :data="listing" border class="mb-8" height="calc(100% - 90px)" style="overflow:auto">
          <el-table-column prop="number" label="清单编码" align="center" min-width="120"></el-table-column>
          <el-table-column prop="type" label="清单类型" align="center" min-width="80"></el-table-column>
          <el-table-column prop="name" label="清单名称" align="center" min-width="200"></el-table-column>
          <el-table-column prop="description" label="清单描述" align="center" min-width="250">
            <template slot-scope="scope">
              <p style="margin-left: 10px;text-align:left;" v-html="scope.row.description"/>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="清单含量" align="center" min-width="160">
            <template slot-scope="scope">
              <a @click="processDetail($event, scope.row.id, scope.row.number, scope.row.name)">明细</a>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" align="center" min-width="80"></el-table-column>
          <el-table-column prop="price" :label="'清单单价' + listRecordDetail.date" align="center" min-width="80"></el-table-column>
          <el-table-column label="操作" align="center" min-width="240" v-if="isAssociation">
            <template slot-scope="scope">
              <!-- <el-button @click="processDetail($event, scope.row.id, scope.row.number, scope.row.name)" size="small">工序明细</el-button> -->
              <el-button @click="machineDetail($event, scope.row.id, scope.row.number, scope.row.name)" size="small">工料机明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex-center">
          <el-pagination
            @current-change="listingPageChange"
            :current-page.sync="listingPageForm.page"
            :page-size="listingPageForm.pageSize"
            layout="prev, pager, next"
            :total="listingPageForm.total"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="基础单价库" name="process" v-if="isAssociation">
        <div class="mb-8 flex-sb">
          <div class="text-center description-content">
            基础单价库共有： {{processPageForm.total}}项
          </div>
          <div>
            <el-input v-model="processSearchForm.search" placeholder="编码/名称" @keyup.enter.native="processPageChange(1)">
              <el-button slot="append" icon="el-icon-search" @click="processPageChange(1)" style="background: #fff;"></el-button>
            </el-input>
          </div>
        </div>
        <el-table :data="process" border class="mb-8" height="calc(100% - 88px)" style="overflow:auto">
          <el-table-column prop="number" label="编码" min-width="150" align="center" label-class-name="header_blue"></el-table-column>
          <el-table-column prop="name" label="名称" min-width="500" align="center" label-class-name="header_blue"></el-table-column>
          <el-table-column prop="unit" label="计量单位" min-width="150" align="center" label-class-name="header_blue"></el-table-column>
          <el-table-column prop="price" label="综合单价" min-width="150" align="center" label-class-name="header_blue"></el-table-column>
        </el-table>
        <div class="flex-center">
          <el-pagination
            @current-change="processPageChange"
            :current-page.sync="processPageForm.page"
            :page-size="processPageForm.pageSize"
            layout="prev, pager, next"
            :total="processPageForm.total"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="清单单价清册说明" name="detailDescriptionPrice">
        <div class="description-content" v-html="listRecordDetail.description_price">
        </div>
      </el-tab-pane>
      <el-tab-pane label="清单计量规则说明" name="detailDescriptionRule">
        <div class="description-content" v-html="listRecordDetail.description_rule">
        </div>
      </el-tab-pane>
      <el-tab-pane label="清单清册编制说明" name="detailDescriptionPrepare">
        <div class="description-content" v-html="listRecordDetail.description_prepare">
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="standardRoomDetailModalTitle + '详情'" :visible.sync="standardRoomDetailModalShow" width="98%" style="height:100%" center id="standardRoomDetailModal">
      <el-table :data="standardRoomListing" border height="100%">
        <el-table-column prop="number" label="清单编码" align="center" min-width="90"></el-table-column>
          <el-table-column prop="type" label="清单类型" align="center" min-width="80"></el-table-column>
          <el-table-column prop="name" label="清单名称" align="center" min-width="200"></el-table-column>
          <el-table-column prop="description" label="清单描述" align="center" min-width="250">
            <template slot-scope="scope">
              <p style="margin-left: 10px;text-align:left;" v-html="scope.row.description"/>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="清单含量" align="center" min-width="100">
            <!-- <template slot-scope="scope">
              <p style="margin-left: 10px;" v-html="scope.row.content"/>
            </template> -->
            <template slot-scope="scope">
              <a @click="processDetail($event, scope.row.id, scope.row.number, scope.row.name)" size="small">明细</a>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" align="center" min-width="50"></el-table-column>
          <el-table-column prop="quantities" label="工程量" align="center" min-width="60"></el-table-column>
          <el-table-column prop="price" :label="'清单单价' + listRecordDetail.date" align="center" min-width="80"></el-table-column>
          <el-table-column prop="totalPrice" label="合价" align="center" min-width="60"></el-table-column>
          <el-table-column label="操作" align="center" min-width="240" v-if="isAssociation">
            <template slot-scope="scope">
              <!-- <el-button @click="processDetail($event, scope.row.id, scope.row.number, scope.row.name)" size="small">工序明细</el-button> -->
              <el-button @click="machineDetail($event, scope.row.id, scope.row.number, scope.row.name)" size="small">工料机明细</el-button>
            </template>
          </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="processDetailModalTitle + '详情'" :visible.sync="processDetailModalShow" width="60%" style="height:100%" center id="processDetailModal">
      <el-table :data="listingProcess" height="100%">
        <el-table-column prop="number" label="编码" min-width="80" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" min-width="200" align="center"></el-table-column>
        <el-table-column prop="unit" label="计量单位" min-width="70" align="center"></el-table-column>
        <el-table-column prop="quantities" label="工程量" min-width="70" align="center"></el-table-column>
        <el-table-column label="金额（元）" align="center" min-width="160">
          <el-table-column prop="price" label="综合单价" min-width="80" align="center"></el-table-column>
          <el-table-column prop="totalPrice" label="合价" min-width="80" align="center"></el-table-column>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="machineDetailModalTitle + '详情'" :visible.sync="machineDetailModalShow" width="60%" style="height:100%" center id="machineDetailModal">
      <el-table :data="listingMachine" height="100%">
        <el-table-column type="index" label="序号" width="90" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" min-width="200" align="center"></el-table-column>
        <el-table-column prop="unit" label="计量单位" min-width="70" align="center"></el-table-column>
        <el-table-column prop="consumption" label="消耗量" min-width="60" align="center"></el-table-column>
        <el-table-column label="金额（元）" align="center" min-width="160">
          <el-table-column prop="price" label="综合单价" min-width="80" align="center"></el-table-column>
          <el-table-column prop="totalPrice" label="合价" min-width="80" align="center"></el-table-column>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  async created () {
    this.detailId = this.$route.params.detailId
    this.getListRecordDetail()
    this.getStandardRoomList()
    await this.getTypeSearchList()
    this.getListingList()
    this.getProcessList()
  },
  data () {
    return {
      isIndeterminate: true,
      checkAll: false,
      standardRoomDetailModalTitle: '',
      standardRoomDetailModalShow: false,
      processDetailModalTitle: '',
      processDetailModalShow: false,
      machineDetailModalTitle: '',
      machineDetailModalShow: false,
      activeName: 'standardRoom',
      typeSearchList: [],
      detailId: null,
      listRecordDetail: {
        name: '',
        version: '',
        safetyRate: '',
        addedValueTaxRate: '',
        description: '124214',
        date: '1'
      },
      standardRoomPageForm: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      standardRoom: [],
      listingSearchForm: {
        type: [],
        search: ''
      },
      listingPageForm: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      listing: [],
      processPageForm: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      processSearchForm: {
        search: ''
      },
      // previousSearchType: [],
      process: [],
      standardRoomListing: [],
      listingProcess: [],
      listingMachine: []
    }
  },
  methods: {
    handleCheckAllChange (val) {
      let all = this.typeSearchList.map((item, index) => index)
      this.listingSearchForm.type = val ? all : []
      this.isIndeterminate = false
      this.listingSearchFormTypeChange(this.listingSearchForm.type)
    },
    downLoadExcel () {
      const appkey = this.$oneitfarm.getAppkey()
      const token = this.$oneitfarm.getToken()
      const channel = this.$oneitfarm.getChannel()
      window.open(`${this.$http.defaults.baseURL}/list_record/excel/?id=${this.detailId}&appkey=${appkey}&token=${token}&channel=${channel}`)
    },
    downLoadPdf () {
      const appkey = this.$oneitfarm.getAppkey()
      const token = this.$oneitfarm.getToken()
      const channel = this.$oneitfarm.getChannel()
      window.open(`${this.$http.defaults.baseURL}/list_record/pdf/?id=${this.detailId}&appkey=${appkey}&token=${token}&channel=${channel}`)
    },
    async getListRecordDetail () {
      let response = (await this.$http.post('/list_record/detail', {
        id: this.detailId
      })).data
      if (response && Number.parseInt(response.ret) === 1) {
        let temp = response.data
        temp.description_price = temp.description_price.replace(/\n/g, '<br/>')
        temp.description_rule = temp.description_rule.replace(/\n/g, '<br/>')
        temp.description_prepare = temp.description_prepare.replace(/\n/g, '<br/>')
        let responseData = temp
        this.listRecordDetail = responseData
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    async getStandardRoomList () {
      let response = (await this.$http.post('/standard_room/all', {
        filter: {
          listRecordID: this.detailId
        },
        page: this.standardRoomPageForm.page,
        limit: this.standardRoomPageForm.pageSize
      })).data
      if (response && Number.parseInt(response.ret) === 1) {
        let responseData = response.data
        this.standardRoom = responseData.items
        this.standardRoomPageForm.total = Number.parseInt(responseData.total)
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    standardRoomPageChange (page) {
      this.standardRoomPageForm.page = page
      this.getStandardRoomList()
    },
    async getListingList () {
      let searchType = this.listingSearchForm.type.map(item => this.typeSearchList[item])
      let response = (await this.$http.post('/listing/all', {
        filter: {
          listRecordID: this.detailId
        },
        page: this.listingPageForm.page,
        limit: this.listingPageForm.pageSize,
        search: this.listingSearchForm.search,
        type_search: searchType
      })).data
      if (response && Number.parseInt(response.ret) === 1) {
        let responseData = response.data
        let result = responseData.items.map(item => {
          // item.content = item.content.replace(/\n/g, '<br/>')
          item.description = item.description.replace(/\n/g, '<br/>')
          return item
        })
        this.listing = result
        this.listingPageForm.total = Number.parseInt(responseData.total)
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    listingPageChange (page) {
      this.listingPageForm.page = page
      this.getListingList()
    },
    async getProcessList () {
      let response = (await this.$http.post('/process/all', {
        filter: {
          listRecordID: this.detailId
        },
        page: this.processPageForm.page,
        limit: this.processPageForm.pageSize,
        search: this.processSearchForm.search
      })).data
      if (response && Number.parseInt(response.ret) === 1) {
        let responseData = response.data
        this.process = responseData.items
        this.processPageForm.total = Number.parseInt(responseData.total)
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    processPageChange (page) {
      this.processPageForm.page = page
      this.getProcessList()
    },
    async getStandardRoomListing (id) {
      let response = (await this.$http.post('/standard_room/listing', {
        standardRoomID: id
      })).data
      if (response && Number.parseInt(response.ret) === 1) {
        let responseData = response.data
        let result = responseData.map(item => {
          // item.content = item.content.replace(/\n/g, '<br/>')
          item.description = item.description.replace(/\n/g, '<br/>')
          return item
        })
        this.standardRoomListing = result
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    standardRoomDetail (event, id, name) {
      this.standardRoomDetailModalTitle = name
      this.getStandardRoomListing(id)
      this.standardRoomDetailModalShow = true
    },
    async getListingProcessDetail (id) {
      let response = (await this.$http.post('/listing/process', {
        listingID: id
      })).data
      if (response && Number.parseInt(response.ret) === 1) {
        let responseData = response.data
        this.listingProcess = responseData
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    async getListingMachineDetail (id) {
      let response = (await this.$http.post('/listing/machine', {
        listingID: id
      })).data
      if (response && Number.parseInt(response.ret) === 1) {
        let responseData = response.data
        this.listingMachine = responseData
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    async getTypeSearchList () {
      let response = (await this.$http.post('/listing/typeSearchList', {})).data
      if (response && Number.parseInt(response.ret) === 1) {
        let responseData = response.data
        this.typeSearchList = responseData
        this.listingSearchForm.type = responseData.map((item, index) => index)
        this.isIndeterminate = false
        this.checkAll = true
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    async listingSearchFormTypeChange (current) {
      this.listingPageForm.page = 1
      let searchType = current.map(item => this.typeSearchList[item])
      let checkedCount = current.length
      this.checkAll = checkedCount === this.typeSearchList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.typeSearchList.length
      let response = (await this.$http.post('/listing/all', {
        filter: {
          listRecordID: this.detailId
        },
        page: this.listingPageForm.page,
        limit: this.listingPageForm.pageSize,
        search: this.listingSearchForm.search,
        type_search: searchType
      })).data
      let currentSearchType = this.listingSearchForm.type.map(item => this.typeSearchList[item])
      if (currentSearchType.length === searchType.length) {
        let equal = currentSearchType.reduce((total, currentItem) => total && searchType.indexOf(currentItem) > -1, true)
        if (equal) {
          if (response && Number.parseInt(response.ret) === 1) {
            let responseData = response.data
            let result = responseData.items.map(item => {
              // item.content = item.content.replace(/\n/g, '<br/>')
              item.description = item.description.replace(/\n/g, '<br/>')
              return item
            })
            this.listing = result
            this.listingPageForm.total = Number.parseInt(responseData.total)
          } else {
            this.$message.error({
              message: response.msg
            })
          }
        } else {
          console.log(1)
        }
      }
    },
    processDetail (event, id, number, name) {
      this.processDetailModalTitle = `${name} (${number}) 基础单价明细`
      this.getListingProcessDetail(id)
      this.processDetailModalShow = true
    },
    machineDetail (event, id, number, name) {
      this.machineDetailModalTitle = `${name} (${number}) 工料机明细`
      this.getListingMachineDetail(id)
      this.machineDetailModalShow = true
    }
  },
  computed: {
    isAssociation () {
      return this.$oneitfarm.hasRole('list.management')
    }
  }
}
</script>
<style>
#standardRoomDetailModal > .el-dialog {
  height: 80%;
}
#standardRoomDetailModal > .el-dialog > .el-dialog__body {
  height: 90%;
}
#processDetailModal > .el-dialog {
  height: 80%;
}
#processDetailModal > .el-dialog > .el-dialog__body {
  height: 90%;
}
#machineDetailModal > .el-dialog {
  height: 80%;
}
#machineDetailModal > .el-dialog > .el-dialog__body {
  height: 90%;
}
#tabs .el-tabs__content {
  height: calc(100% - 55px);
}
#tabs .el-tabs__content > .el-tab-pane {
  height: 100%;
  overflow: auto
}
#tabs .el-table td, #tabs .el-table th {
  padding: 0;
}
/* #tabs .el-table .cell, #tabs .el-table th div, #tabs .el-table--border td:first-child .cell, #tabs .el-table--border th:first-child .cell {
  padding-left: 0;
}
#tabs .el-table .cell, #tabs .el-table th div {
  padding-right: 0;
} */
</style>

<style scoped>
.content {
  height: calc(100% - 58px);
}
.header_blue {
  /* background-color: aqua;
  padding: 0; */
}
.text-center {
  height: 40px;
  line-height:40px;
}
.detail-title {
  font-family: 'MicrosoftYaHei', 'Microsoft YaHei';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #434343;
}
.description-content {
  font-family: 'MicrosoftYaHei', 'Microsoft YaHei';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #6B6B6B;
}
.icon-text {
  font-family: 'MicrosoftYaHei', 'Microsoft YaHei';
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: #949494;
}
</style>
